import { render, staticRenderFns } from "./sign-in-sufe.vue?vue&type=template&id=12e4ed74&scoped=true"
import script from "./sign-in-sufe.vue?vue&type=script&lang=js"
export * from "./sign-in-sufe.vue?vue&type=script&lang=js"
import style0 from "./sign-in-sufe.vue?vue&type=style&index=0&id=12e4ed74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e4ed74",
  null
  
)

export default component.exports